"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var service_service_1 = require("src/app/Services/service.service");
var core_2 = require("@angular/core");
var WickedApiClient_1 = require("src/app/api/WickedApiClient");
var ngx_cookie_service_1 = require("ngx-cookie-service");
var player_1 = require("@vimeo/player");
var router_2 = require("@angular/router");
var searchroute_service_1 = require("./../../../Services/searchroute.service");
var geolocation_service_1 = require("./../../../Services/geolocation.service");
var home_component_1 = require("./../../../home/home.component");
function compare(a, b) {
    if (a.name < b.name) {
        return -1;
    }
    if (a.name > b.name) {
        return 1;
    }
    return 0;
}
var MobileHomeComponent = /** @class */ (function (_super) {
    __extends(MobileHomeComponent, _super);
    function MobileHomeComponent(service, geolocationService, cookieService, route, activeRoute, searchRouteService, renderer2, _document) {
        var _this = _super.call(this, service, geolocationService, cookieService, route, activeRoute, searchRouteService) || this;
        _this.service = service;
        _this.geolocationService = geolocationService;
        _this.cookieService = cookieService;
        _this.route = route;
        _this.renderer2 = renderer2;
        _this._document = _document;
        _this._mostPopularCities = [];
        service.pageName = "Search";
        return _this;
    }
    Object.defineProperty(MobileHomeComponent.prototype, "showWickedVideo", {
        get: function () {
            return this.service.showStartVideo;
        },
        set: function (val) {
            this.service.showStartVideo = val;
        },
        enumerable: true,
        configurable: true
    });
    MobileHomeComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        //   const s = this.renderer2.createElement('script');
        //  s.onload = this.loadNextScript.bind(this);
        //  s.type = 'text/javascript';
        //  s.src = 'https://poweredby.jads.co/js/jads.js'; // Defines someGlobalObject
        //  s.text = ``;
        //  this.renderer2.appendChild(this._document.body, s);
    };
    MobileHomeComponent.prototype.loadNextScript = function () {
        console.log("SCRIPT LOADED");
        // const s = this.renderer2.createElement('script');
        // s.setAttribute('data-cfasync', 'false');
        // s.text = `(adsbyjuicy = window.adsbyjuicy || []).push({'adzone':929577});`
        // this.renderer2.appendChild(this._document.body, s);
    };
    MobileHomeComponent.prototype.ngAfterViewInit = function () {
        //const adsbyjuicy = (window["adsbyjuicy"] || []).push({'adzone':929577});
        // console.log(window);
        // console.log(window["adsbyjuicy"]);
        var _this = this;
        if (this.showWickedVideo) {
            var player = new player_1.default(this.wickedVideo.nativeElement, { id: 373344002, byline: false, portrait: false, title: false, autoplay: true, width: this.wickedVideo.nativeElement.offsetWidth, height: this.wickedVideo.nativeElement.offsetHeight });
            player.ready().catch(function (e) {
                _this.showWickedVideo = false;
            });
            player.on("play", function () {
                _this.cookieService.set("hiddenVideo", "true");
            });
            player.on("ended", function () {
                _this.showWickedVideo = false;
            });
            player.on("error", function () {
                _this.showWickedVideo = false;
            });
        }
    };
    return MobileHomeComponent;
}(home_component_1.HomeComponent));
exports.MobileHomeComponent = MobileHomeComponent;
